<template>
  <div>
    <PageHead title="医药费报销列表"></PageHead>
    <div class="oa-layout-content">
      <!-- 顶部检索条件 -->
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">报销职工名称：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入"
                v-model="queryForm.fullName"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">报销年度：</div>
              <a-select
                allowClear
                placeholder="请选择"
                class="w200"
                v-model="queryForm.year"
              >
                <a-select-option
                  v-for="(item, index) in yearList"
                  :key="index"
                  :value="item"
                  >{{ item + '年度' }}</a-select-option
                >
              </a-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">表单状态：</div>
              <a-select
                allowClear
                placeholder="请选择"
                class="w200"
                v-model="queryForm.state"
              >
                <a-select-option
                  v-for="(item, index) in $store.state.app.formStatusList"
                  :key="index"
                  :value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>

      <blank height="12"> </blank>
      <!-- 查询按钮之下 -->
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">订单类型：</div>
              <a-select
                allowClear
                placeholder="请选择"
                class="w200"
                v-model="queryForm.type"
              >
                <a-select-option
                  v-for="(item, index) in orderTypeList"
                  :key="index"
                  :value="Number(item.value)"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">部门：</div>
              <a-tree-select
                allowClear
                v-model="organizationId"
                style="width: 360px"
                multiple
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="请选择部门"
                tree-default-expand-all
                :replaceFields="{
                  key: 'id',
                  value: 'id',
                  children: 'treeList',
                  title: 'organizationName'
                }"
              >
              </a-tree-select>
            </div>
          </div>
        </div>
      </div>

      <div class="mb20 search-btns mt20">
        <a-button class="mr10" type="primary" @click="add(2, 1)" icon="plus">
          申请</a-button
        >
        <a-button type="primary" @click="add(3, 1)" icon="plus">
          代客下单</a-button
        >
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (queryForm.page - 1) * 10 }}
        </span>
        <span slot="disposalstate" slot-scope="text">{{ text }}</span>
        <div slot="type" slot-scope="text">
          <template v-if="text == 1">自助报销</template>
          <template v-if="text == 2">在职下单</template>
          <template v-if="text == 3">代客下单</template>
        </div>

        <div slot="fromState" class="statusDiv" slot-scope="text, record">
          <div :class="'dot' + text + ' mr5'"></div>
          <span
            v-for="(item, index) in $store.state.app.formStatusList"
            :key="index"
          >
            <span v-if="text == item['value']">{{ item.label }}</span>
          </span>
          <span></span>
        </div>
        <!-- 操作 -->
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetail(record, 3)">
            查看
          </a-button>

          <template v-if="record.state == 0">
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="goDetail(record, 2)">
              修改
            </a-button>
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="showDeleteConfirm(record.id)"
            >
              删除
            </a-button>
          </template>
          <!-- <a-divider type="vertical" v-if="record.recallButton" /> -->
          <!-- <a-button
            v-if="record.recallButton"
            type="link"
            class="btn-link"
            @click="showRecallConfirm(record)"
          >
            撤回
          </a-button> -->
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="queryForm.page"
          :default-current="queryForm.page"
          :total="total"
          :pageSize="queryForm.size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    align: 'center',
    width: 80
  },
  {
    title: '报销职工姓名',
    dataIndex: 'userName',
    key: 'userName',
    ellipsis: true
  },
  {
    title: '所在部门',
    dataIndex: 'departmentName',
    key: 'departmentName',
    ellipsis: true
  },
  {
    title: '报销年度',
    dataIndex: 'year',
    key: 'year',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '手机号码',
    dataIndex: 'phoneNumber',
    key: 'phoneNumber',
    align: 'center'
    // width: 80,
  },

  {
    title: '订单类型',
    dataIndex: 'type',
    key: 'type',
    scopedSlots: { customRender: 'type' },
    ellipsis: true
  },
  {
    title: '审批状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'fromState' },
    ellipsis: true,
    align: 'left'
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    width: 180,
    align: 'left'
  }
]
import { deleteDisposition } from './api/api'
import { recallProcessFn } from '@/utils/utils'
import { mapState, mapActions } from 'vuex'
import { medicalReimbursementPatchList, getYear, getTreeList } from './api/api'
export default {
  data() {
    return {
      expand: false,
      queryForm: {
        page: 1,
        size: 10
      },
      tableData: [],
      columns,
      total: 0,
      yearList: ['2022', '2021', '2020'], // 下拉查询
      orderTypeList: [
        { value: '1', label: '自助报销' },
        { value: '2', label: '在职下单' },
        { value: '3', label: '代客下单' }
      ], // 下拉订单类型 前端写死
      loading: false,
      organizationId: []
      // treeData: []
    }
  },

  created() {
    // this.getYearFn()
    this.getorganizeListFn()
    this.getList()
  },
  computed: {
    ...mapState({
      treeData: (state) => state.app.treeData // 组织机构树
    })
  },
  watch: {
    organizationId: {
      handler(val) {
        if (!this.isEmpty(val)) {
          this.queryForm.organizationId = val.join(',')
        } else {
          this.queryForm.organizationId = ''
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['getorganizeListFn']),
    // 年度下拉
    // getYearFn() {
    //   getYear().then((res) => {
    //     if (res.data.code == 0) {
    //       this.yearList = res.data.data
    //     }
    //   })
    // },
    // 提交 未审批 可撤回流程
    showRecallConfirm(record) {
      const recallProcessPromise = new Promise((resolve, reject) => {
        recallProcessFn(this, record, resolve, reject, 'd-fixe-dasset')
      })
      recallProcessPromise
        .then((value) => {
          console.log(value)
          this.getList()
        })
        .catch((error) => {
          console.log(error)
          this.getList()
        })
    },
    // 顶部搜索 取消
    cancel() {
      this.queryForm = {
        page: 1,
        size: 10
      }
      this.organizationId = []
    },
    // 顶部搜索 查询
    subMit() {
      this.page = 1
      this.getList()
    },
    // 拉取列表
    getList() {
      this.loading = true
      medicalReimbursementPatchList(this.queryForm).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.count
        }
      })
    },
    // 删除
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          deleteDisposition(id).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.getList()
            }
          })
        }
      })
    },
    // 判断是代客下单还是申请仅相差一个代办人字段 type 为1自助报销 2 在职 为3代客下单
    // 判断是新增 修改与查询 index  1新增 2修改 3查看详情
    // index： 1新增
    add(type, index) {
      this.$router.push(`/MedicalFeeDetail?type=${type}&index=${index}`)
    },
    // 查看 全部置灰 index 为 3查看详情 2修改
    goDetail(record, index) {
      this.$router.push(
        `/MedicalFeeDetail?id=${record.id}&type=${record.type}&index=${index}`
      )
      // this.$router.push(
      //   '/MedicalFeeDetail?id=' +
      //     record.id +
      //     '&type=' +
      //     record.type +
      //     '&index=' +
      //     index
      // )
    },
    // 列表分页器
    pageChange(val) {
      this.queryForm.page = val
      this.getList()
    },
    getTreeListFn() {
      getTreeList().then((res) => {
        this.treeData = res.data.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  // justify-content: space-between;
  .query-top-select {
    // width: calc(100% - 200px);
    .query-cont {
      display: flex;
      align-items: center;
      // justify-content: space-between;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 20px 20px 0;
        .query-view-lable {
          width: 100px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}
.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/MedicalFee/index.vue